// extracted by mini-css-extract-plugin
module.exports = {"form":"LangButton_form__QRXJw"};